import { useSettings } from "~/store/settings";
import { DateTime as Luxon } from "luxon";

export default function initialiseNativeAppCookies() {
	const store = useSettings();
	const route = useRoute();

	// App init
	const { IsNativeApp, appType, hasNativeLobby, isSynapseV2, autoLogin, showInGameHeader } = route.query;

	// Use query params
	if (IsNativeApp && appType) {
		store.setNativeAppSettings(
			Boolean(store.isDataFree ? false : IsNativeApp),
			appType as string,
			Boolean(hasNativeLobby),
			String(isSynapseV2),
			String(autoLogin),
			Boolean(showInGameHeader)
		);

		// Set cookies
		const expiry = {
			expires: Luxon.now().plus({ days: 7 }).toJSDate(),
		};
		const isNativeAppCookie = useCookie("isNativeApp", expiry);
		const appTypeCookie = useCookie("appType", expiry);
		const hasNativeLobbyCookie = useCookie("hasNativeLobby", expiry);
		const hasSynapseV2Cookie = useCookie("isSynapseV2", expiry);
		const hasAutoLoginCookie = useCookie("autoLogin", expiry);
		const showInGameHeaderCookie = useCookie("showInGameHeader", expiry);
		hasAutoLoginCookie.value = autoLogin as string;
		isNativeAppCookie.value = IsNativeApp as string;
		appTypeCookie.value = appType as string;
		hasNativeLobbyCookie.value = hasNativeLobby as string;
		hasSynapseV2Cookie.value = isSynapseV2 as string;
		showInGameHeaderCookie.value = showInGameHeader as string;
	} else {
		// Use cookies
		const isNativeApp = useCookie("isNativeApp");
		const appType = useCookie("appType");
		const hasNativeLobby = useCookie("hasNativeLobby");
		const autoLogin = useCookie("autoLogin");
		const isSynapseV2 = useCookie("isSynapseV2");
		const showInGameHeader = useCookie("showInGameHeader");

		store.setNativeAppSettings(
			Boolean(isNativeApp.value),
			String(appType.value),
			Boolean(hasNativeLobby.value),
			String(isSynapseV2.value),
			String(autoLogin.value),
			Boolean(showInGameHeader.value)
		);
		store.setNativeAppSettings(
			Boolean(isNativeApp.value),
			String(appType.value),
			Boolean(hasNativeLobby.value),
			String(isSynapseV2.value),
			String(autoLogin.value),
			Boolean(showInGameHeader.value)
		);
	}
}
